/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.1.2
 */

/**
 * Role of the user
 */
export type UserBodyDtoRole =
  (typeof UserBodyDtoRole)[keyof typeof UserBodyDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserBodyDtoRole = {
  admin: 'admin',
  adminViewOnly: 'adminViewOnly',
  basic: 'basic',
  delegate: 'delegate',
  focalPoint: 'focalPoint',
  referenceCenter: 'referenceCenter',
  validated: 'validated',
} as const;
